module.exports = __webpack_public_path__ + "img/introduce01_img02.4b190358.png";